import { DEFAULT_COLOR } from '../../../constants/defaultColor'
import { DEFAULT_FONT } from '../../../constants/defaultFont'
import type { LogoAndBrandingSettingsFormValues } from '../types/logoAndBrandingSettingsFormValues'

export const getLogoAndBrandingSettingsDefaultValues = (
  predefinedValues?: Partial<LogoAndBrandingSettingsFormValues>,
): LogoAndBrandingSettingsFormValues => {
  return {
    logoId: predefinedValues?.logoId || null,
    logoUrl: predefinedValues?.logoUrl || undefined,
    shouldApplyTemplateColorToColumnHeaders: predefinedValues?.shouldApplyTemplateColorToColumnHeaders ?? true,
    shouldApplyTemplateColorToDividers: predefinedValues?.shouldApplyTemplateColorToDividers ?? true,
    shouldApplyTemplateColorToHeader: predefinedValues?.shouldApplyTemplateColorToHeader ?? true,
    shouldApplyTemplateColorToTotal: predefinedValues?.shouldApplyTemplateColorToTotal ?? true,
    templateColor: predefinedValues?.templateColor || DEFAULT_COLOR,
    templateFont: predefinedValues?.templateFont || DEFAULT_FONT,
  }
}
